var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-item"},[_c('video',{ref:"videoStream",attrs:{"src":_vm.videoSrc,"autoplay":_vm.autoplay,"controls":_vm.controls,"type":"video/*"},domProps:{"muted":_vm.muted},on:{"error":_vm.onVideoError}})])}
var staticRenderFns = []

export { render, staticRenderFns }